import { FunctionComponent, useState } from 'react';
import { Tab } from '@headlessui/react';
import classNames from 'classnames';
import { usePlayground, usePlaygroundMutations } from '@playground/context/hooks';

import Guide from '@playground/components/Guide';
import Tests from '@playground/SQL/components/Tests';
import Terminal from '@playground/SQL/components/Terminal';
import { useTranslation } from 'next-i18next';

const Tabs: FunctionComponent = () => {
  const { exercise, runner } = usePlayground();
  const { setRunner } = usePlaygroundMutations();
  const { t } = useTranslation('common');

  const [tabs] = useState([
    {
      title: t('codeRunner.guide'),
      content: (
        <Guide
          showCourse={runner.mode === 'external'}
          ctaLink={exercise?.path?.cta?.link ?? ''}
          ctaText={exercise?.path?.cta?.text ?? ''}
          content={exercise?.mdContent ?? ''}
        />
      ),
    },
    {
      title: 'Console',
      content: <Terminal />,
    },
    {
      title: t('codeRunner.tests'),
      content: <Tests />,
    },
  ]);

  return (
    <div className="w-full h-full flex flex-col">
      <Tab.Group
        defaultIndex={0}
        selectedIndex={runner.currentTabIndex}
        onChange={(index) => {
          setRunner({ currentTabIndex: index });
        }}
      >
        <Tab.List className="flex my-4 space-x-1 border-b border-stone-50">
          {tabs.map((item, index) => (
            <Tab
              key={`tab-${index}`}
              className={({ selected }) =>
                classNames(
                  'w-full py-2.5 text-sm font-bold leading-5 text-white-700 focus:outline-none  focus:ring-0 focus:ring-offset-0',
                  {
                    'text-platzi-blue border-platzi-blue border-b-4': selected,
                    'hover:text-platzi-blue': !selected,
                  }
                )
              }
            >
              {item.title}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="h-full grow overflow-hidden">
          {tabs.map((item, index) => (
            <Tab.Panel key={`content-${index}`} className="h-full">
              {item.content}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default Tabs;
